import React from 'react'
import FWOTextInput from '../form/FWOTextInput'
import { SharedControlProps, Tooltips } from '../../models/Common'

const FWOPhone = (props: SharedControlProps) => {
  return (
    <>
      <FWOTextInput
        name={props.name}
        required={props.required}
        ariaLabel={props.label}
        label={props.label}
        placeholder={props.placeholder}
        tooltip={props.tooltip ?? Tooltips.PhoneGeneralTooltip}
        type="text"
        showreadonly={props.showreadonly}
        showOptional={props.showOptional}
      />
    </>
  )
}

export default FWOPhone
